import { Component, Input } from '@angular/core';

import { CandidateAdapter, Skill } from '@shared/models';

@Component({
  selector: 'mojo-candidate-resume',
  templateUrl: './candidate-resume.component.html',
  styleUrls: ['./candidate-resume.component.scss'],
})
export class CandidateResumeComponent {
  @Input() keywords: string[];

  @Input() candidate: CandidateAdapter;

  @Input() softSkills: Array<Skill>;
  @Input() hardSkills: Array<Skill>;
}
